import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import ReservationDetail from '@components/ringil3/Features/Reservation/ReservationDetail';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { PermissionTypesEnum } from '@api/ringil-api.v2';
import { useParams } from 'react-router-dom';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {}

const ReservationDetailPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  const { reservationId } = useParams();

  return (
    <>
      <ResponsiveLayout
        layout="detail"
        title={tr(`ReservationDetail.reservationDetail`, `Reservation detail`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_TIMESLOT_DETAIL_RW, PermissionTypesEnum.PERMISSION_TIMESLOT_DETAIL_READ]}
      >
        <ReservationDetail reservationId={reservationId} />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(ReservationDetailPage);
